export const CREATE_ORDER_SUCCESS = "CREATE_ORDER_SUCCESS";
export const CREATE_ORDER_REQUEST = "CREATE_ORDER_REQUEST";
export const CREATE_ORDER_FAIL = "CREATE_ORDER_FAIL";
export const BUY_NOW = "BUY_NOW"
// export const CREATE_ORDER_HISTORY = "CREATE_ORDER_HISTORY";
